export default "__VITE_ASSET__Bx0OKLlw__"